import { Star } from '@zoomit/icons';
import { cn } from '@zoomit/primitives';

import { scoreColor } from '../../helpers/score';

type Props = {
  score: number;
  isReverse?: boolean;
  reviewCounts?: number;
  className?: string;
};

const Score = (props: Props) => {
  const { score, isReverse = false, reviewCounts, className } = props;
  return (
    <div
      className={cn('flex items-center gap-1', isReverse ? 'row-reverse' : 'row', className)}
      aria-label="امتیاز کاربران"
      role="status"
    >
      <div className="bg-borderPrimary text-subhead flex items-center justify-center gap-0.5 rounded-full px-1.5 py-1">
        <Star fill={scoreColor(score)} size="sm" />
        <div className="fa leading-none" style={{ color: scoreColor(score) }}>
          {score}
        </div>
      </div>

      {reviewCounts && <span className="fa text-callout text-grey1">از {reviewCounts} رای</span>}
    </div>
  );
};

export default Score;
